// Motivo de cancelamento digitado pela loja: 8+ caracteres e pelo menos uma
// letra ("...." passava). Mesma regra do servidor (api/v1/pedidos/cancel.py).
export const MOTIVO_MIN_CARACTERES = 8;

export function motivoValido(motivo) {
  const texto = (motivo || "").trim();
  return texto.length >= MOTIVO_MIN_CARACTERES && /\p{L}/u.test(texto);
}
